const styles = {
  container: {
    background: '#fff',
    marginBottom: '30px',
    padding: '30px 0 0',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)'
  },
  links: {
    display: 'flex',
    padding: '0',
    margin: '0',
    listStyle: 'none',
    justifyContent: 'center'
  }
}

export default styles
